/*
 * @FileName       : reports.saga.js
 * @Version        : 1.0
 * @DateOfCreation : 04/21/2020
 * @Author         : $u^^!t @ FFF Enterprises
 * @Dependencies   : N/A
 * @Description    : User saga to store all the reports events.
 *
 * Copyright (c) 2020, FFF Enterprises. All rights reserved.
 */

import { call, put, delay } from 'redux-saga/effects';
import { InvoicesActions, UIAction, UserActions } from '../actions/index';
import { InvoicesService, TenantsService } from '../services';
import config from '../../config';
import { Constants } from '../../constants/Constants';

export function* getInvoicesList(action: ReturnType<typeof InvoicesActions.getInvoiceList>): any {
	try {
		yield put(UIAction.showLoader(true));
		yield put(UIAction.setApiError(null));

		const cidObj = action.payload.find((pi: any) => {
			return pi.key === 'customerId';
		});

		if (!cidObj) {
			throw new Error('No customer id found for getInvoicesList');
		}

		const cid = cidObj.value;

		//let ccData: any;
		const { data } = yield call(InvoicesService.getInstance().fetchInvoices, action.payload);
		//ccData = yield call(TenantsService.getInstance().getCreditCardEligibleProductsForCustomer, cid);
		//const ccPayableProductIds: string[] = [];

		if (!data || data?.results?.length === 0) {
			yield put(
				UserActions.setSnackbarMessage({
					message: Constants.ALERT.NO_RECORD_FOUND,
					type: 'info',
				}),
			);
		} else {
			// if (ccData.data?.length) {
			// 	//assemble cc-eligible ids into an array for simple checking
			// 	//todo: this service returns way too much when we only need the id
			// 	ccData.data?.forEach((parObj: any) => {
			// 		ccPayableProductIds.push(parObj.productItemId);
			// 	});

				data.results.forEach((invObj: any) => {
					invObj.isCCPaymentEligible = determineIfIsCCPaymentEligible(invObj);
				});
			//}
		}

		console.log('invoice data', data);

		yield put(InvoicesActions.successInvoiceList(data));
		yield put(UIAction.showLoader(false));
	} catch (err: any) {


		yield put(InvoicesActions.successInvoiceList(null));
		yield put(UIAction.showLoader(false));
		const errorMessage = err.message.includes('403') ? Constants.ALERT.NOT_AUTHORIZED : Constants.ALERT.SERVER_ERROR;

		yield put(
			UserActions.setSnackbarMessage({
				message: `An error occurred: ${errorMessage} in getInvoicesList`,
				type: 'error',
			}),
		);
	}

	function determineIfIsCCPaymentEligible(invObj: any) {
		//TODO: not sure about this terminology!! this param is just made up to work with mock data for now on 7/19/23
		return Boolean(invObj.PaymentMethod === 'ccPayable');


		// if (!ccPayableProductIds.length || !invObj.InvoicedProducts?.length) {
		// 	return false;
		// }

		// let isEligible = true;

		// invObj.InvoicedProducts.forEach((ip: any) => {
		// 	if (!ccPayableProductIds.includes(ip.ProductNumber)) {
		// 		isEligible = false;
		// 	}
		// });

		// return isEligible;
	}
}

/*
* open page hosted by Converge for credit card payment 
* of an eligible invoice!
*/
export function* openPaymentPage(action: ReturnType<typeof InvoicesActions.openInvoicePaymentPage>) {
	try {
		yield put(UIAction.showLoader(true));

		//We encode info into the sessionToken
		//on the backend, it will contact elevon based on terminal creds specified in env variables
		//in order for it to know which terminal, we need `manufacturerName` in the payload

		const { data } = yield call(InvoicesService.getInstance().getPaymentSessionToken, action.payload);

		console.log('SESS TOKEN', data);

		if (!data || data.error) {
			yield put(UIAction.showLoader(false));
			console.error('Error getting token From Converge');
			return;
		}

		const sessionToken = encodeURIComponent(data);
		const hostedPaymentUrl = config.invoicePayment.url + sessionToken;

		window.open(hostedPaymentUrl, '_blank');

		yield put(UIAction.showLoader(false));
	} catch (err) {
		yield put(UIAction.showLoader(false));
		console.log('invoice saga error', err);
	}
}

export function* paymentConfirmation(action: ReturnType<typeof InvoicesActions.paymentConfirmation>) {
	try {
		yield put(UIAction.setApiError(null));
		yield put(InvoicesActions.setPaymentConfirmed(false));
		yield call(InvoicesService.getInstance().paymentConfirmation, action.payload);
		yield put(InvoicesActions.setPaymentConfirmed(true));
	} catch (err) {
		console.log('invoice saga error', err);
		yield put(InvoicesActions.setPaymentConfirmed(true));

		yield put(
			UserActions.setSnackbarMessage({
				message: `An error occurred: ${Constants.ALERT.FAILED_TO_UPDATE_SAP}`,
				type: 'error',
			}),
		);
	}
}

export function* getInvoiceRequests(action: ReturnType<typeof InvoicesActions.getInvoiceRequests>) {
	try {
		yield put(UIAction.showLoader(true));
		const { data } = yield call(InvoicesService.getInstance().getInvoiceRequests, action.payload);
		yield put(InvoicesActions.setInvoiceRequests(data));
		yield put(UIAction.showLoader(false));
		if (!data.results || data.results.length === 0) {
			yield put(UserActions.setSnackbarMessage({
			  message: Constants.ALERT.NO_RECORD_FOUND,
			  type: 'info'
			}));
		  }
	} catch (err: any) {
		console.log('gettting invoice requests saga error', err);

		yield put(
			UserActions.setSnackbarMessage({
				message: 'Failed to get invoice requests: ' + err.message,
				type: 'error',
			}),
		);
		yield put(UIAction.showLoader(false));
	}
}

export function* patchInvoiceRequestAbwSelection(
	action: ReturnType<typeof InvoicesActions.patchInvoiceRequestAbwSelection>,
) {
	try {
		yield put(UIAction.showLoader(true));
		console.log('patchInvoiceRequestAbwSelection payload: ', action.payload);
		yield call(InvoicesService.getInstance().patchInvoiceRequestAbw, action.payload.data);
		if (action.payload.onSuccess) {
			action.payload.onSuccess();
		}
		yield put(UIAction.showLoader(false));
	} catch (err: any) {
		console.error('patching invoices ABW settings saga error', err, 'payload: ', action.payload);

		yield put(
			UserActions.setSnackbarMessage({
				message: 'Failed to update invoices ABW settings: ' + err.message,
				type: 'error',
			}),
		);
		yield put(UIAction.showLoader(false));
	}
}

export function* patchInvoiceRequestStatus(action: ReturnType<typeof InvoicesActions.updateInvoiceStatus>) {
	try {
		yield put(UIAction.showLoader(true));

		yield call(InvoicesService.getInstance().updateInvoiceStatus, action.payload.invoiceId, action.payload.status);

		if (action.payload.onSuccess) {
			action.payload.onSuccess();
		}
		yield put(UIAction.showLoader(false));
	} catch (err: any) {
		console.log('patching invoice ABW setting saga error', err);

		yield put(
			UserActions.setSnackbarMessage({
				message: 'Failed to update invoice ' + action.payload.invoiceId + ' status: ' + err.message,
				type: 'error',
			}),
		);
		yield put(UIAction.showLoader(false));
	}
}

export function* patchInvoiceRequestOmittal(action: ReturnType<typeof InvoicesActions.patchInvoiceRequestOmittal>) {
	try {
		yield put(UIAction.showLoader(true));
		yield call(InvoicesService.getInstance().patchInvoiceRequestOmittal, action.payload);
		yield put(UIAction.showLoader(false));
		action.payload.onSuccess();
	} catch (err: any) {
		console.log('patching invoice ABW setting saga error', err);

		yield put(
			UserActions.setSnackbarMessage({
				message: 'Failed to patch invoice ' + action.payload.invoiceId + ' ABW setting: ' + err.message,
				type: 'error',
			}),
		);
		yield put(UIAction.showLoader(false));
	}
}

export function* patchInvoiceRequestOmittalBulk(action: ReturnType<typeof InvoicesActions.patchInvoiceRequestOmittal>) {
	try {
		yield put(UIAction.showLoader(true));
		yield call(InvoicesService.getInstance().patchInvoiceRequestOmittalBulk, action.payload);
		yield put(UIAction.showLoader(false));
		action.payload.onSuccess();
	} catch (err: any) {
		console.log('patching invoice ABW setting saga error', err);

		yield put(
			UserActions.setSnackbarMessage({
				message: 'Failed to patch invoice ' + action.payload.invoiceId + ' ABW setting: ' + err.message,
				type: 'error',
			}),
		);
		yield put(UIAction.showLoader(false));
	}
}

export function* patchMakeAllInvoicesReady(action: ReturnType<typeof InvoicesActions.patchMakeAllInvoicesReady>) {
	try {
		yield put(UIAction.showLoader(true));
		console.log('patchMakeAllInvoicesReady invoices SAGA');
		yield call(
			InvoicesService.getInstance().patchMakeAllInvoicesReady,
			action.payload && action.payload.filters ? action.payload.filters : null,
		);
		if (action.payload && action.payload.onSuccess) {
			action.payload.onSuccess();
		}
		yield put(UIAction.showLoader(false));
	} catch (error: any) {
		console.error('Patching to make all invoices ready failed with error: ', error);

		yield put(
			UserActions.setSnackbarMessage({
				message: 'Failed to patch invoices and make them all "Ready"',
				type: 'error',
			}),
		);
		yield put(UIAction.showLoader(false));
	}
}

export function* sendAbwReminderEmail(action: ReturnType<typeof InvoicesActions.sendAbwReminderEmail>) {
	try {
		yield put(UIAction.showLoader(true));
		yield call(InvoicesService.getInstance().sendAbwReminderEmail, action.payload);
		yield put(UIAction.showLoader(false));
	} catch (error: any) {
		console.error('Sending ABW Reminder E-Mail failed with error: ', error);

		yield put(
			UserActions.setSnackbarMessage({
				message: 'Failed to send ABW Reminder E-Mail',
				type: 'error',
			}),
		);
		yield put(UIAction.showLoader(false));
	}
}

export function* transmitRequestsToSap(action: ReturnType<typeof InvoicesActions.transmitRequestsToSap>) {
	try {
		yield put(UIAction.showLoader(true));
		const { data } = yield call(InvoicesService.getInstance().transmitRequestsToSap, action.payload);

		let transmitResultMsg = ``;
		data.transmitResults.forEach((result: any) => {
			transmitResultMsg += `${result.linesTransmitted} invoice lines transmitted under file ${result.sapXmlFileName}.
`;
		});

		yield put(UIAction.showLoader(false));
		yield put(
			UserActions.setSnackbarMessage({
				snackbarAutohide: null,
				message: transmitResultMsg,
				type: 'success',
			}),
		);
	} catch (error: any) {
		console.log('Transmitting Requests to SAP failed with error: ', error);

		yield put(
			UserActions.setSnackbarMessage({
				message: 'Failed to transmitting invoice requests to SAP',
				type: 'error',
			}),
		);
		yield put(UIAction.showLoader(false));
	}
}
